module.exports = __webpack_public_path__ + "static/media/cd-logo.52dc06ee.png";